// extracted by mini-css-extract-plugin
module.exports = {"root":"separator_root__3BNWs","separator":"separator_separator__2M--O"};